import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './SelfieVideosPage.module.css';
import { RxAvatar } from "react-icons/rx";
import apiRequest from '../../lib/apiRequest';
import logger from '../../lib/logger';
import SearchBox from '../../components/searchBox/SearchBox';
import Pagination from '../../components/pagination/Pagination'; // 📌 import your Pagination component

const SelfieVideosPage = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isAiSearch, setIsAiSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1); // 📌 new
  const [totalPages, setTotalPages] = useState(1);   // 📌 new
  const perPage = 18; // 📌 can customize if needed

  // Load videos initially and on page change
  useEffect(() => {
    const fetchVideos = async () => {
      setLoading(true);
      try {
        const res = await apiRequest(`/videos/selfieVideos?page=${currentPage}&perPage=${perPage}`);
        setResults(res.data.videos || []);
        const total = res.data.total || res.data.videos.length || 0; // Fallback to length if total not provided
        console.log(total);
        console.log(total/perPage);
        setTotalPages(Math.ceil(total / perPage));
      } catch (err) {
        logger.error('Failed to fetch selfie videos:', err);
        setError('Could not load videos. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (!isAiSearch) {
      fetchVideos();
    }
  }, [currentPage, isAiSearch]); // 📌 triggers when page or mode changes

  // Regular keyword search
  const handleSearch = async () => {
    setIsAiSearch(false);
    setCurrentPage(1); // Reset page
    setLoading(true);
    setError('');
    try {
      const res = await apiRequest.post('/search/normal-search', { query: searchValue });
      setResults(res.data.results || []);
      setTotalPages(1); // Keyword search, disable pagination
    } catch (err) {
      logger.error('Keyword search failed:', err);
      setError('Failed to perform search.');
    } finally {
      setLoading(false);
    }
  };

  // AI search
  const handleAiSearch = async () => {
    setIsAiSearch(true);
    setCurrentPage(1); // Reset page
    setLoading(true);
    setError('');
    try {
      const res = await apiRequest.post('/search/ai-search', { chat_history: searchValue });
      setResults(res.data.results || []);
      setTotalPages(1); // AI search, disable pagination
    } catch (err) {
      logger.error('AI search failed:', err);
      setError(err.response?.data?.error || 'Failed to perform AI search.');
    } finally {
      setLoading(false);
    }
  };

  // Change page
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.headerSection}>
        <SearchBox
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          onSearch={handleSearch}
          onAiSearch={handleAiSearch}
          isAiSearch={isAiSearch}
          loading={loading}
        />
      </div>

      {loading ? (
        <div style={{ padding: '20px' }}>Loading...</div>
      ) : error ? (
        <div style={{ padding: '20px', color: 'red' }}>{error}</div>
      ) : results.length === 0 ? (
        <div style={{ padding: '20px' }}>No videos to display.</div>
      ) : (
        <>
          <div className={styles.movieListContainer}>
            {results.map((video) => (
              <div key={video.movieId || video._id} className={styles.movieCard}>
                <Link
                  to={`/selfieVideos/${video.movieId || video._id}`}
                  className={styles.videoLink}
                >
                  <div className={styles.thumbnailWrapper}>
                    <img
                      src={video.thumbnailCdnUrl || 'default-thumb.jpg'}
                      alt={video.title}
                      className={styles.movieThumbnail}
                    />
                  </div>
                  <h5 className={styles.movieTitle}>{video.title}</h5>
                </Link>
                <div className={styles.movieInfo}>
                  {video.username && video.user && (
                    <Link to={`/profile/${video.user}`} className={styles.usernameLink}>
                      <p className={styles.movieUsername}><RxAvatar /> {video.username}</p>
                    </Link>
                  )}
                  <p className={styles.movieViews}>{video.views || 0} views</p>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination only if more than 1 page */}
          {totalPages > 1 && !isAiSearch && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>
      )}
    </div>
  );
};

export default SelfieVideosPage;
